import { useReactNavigationDevTools as useReactNavigationVisualizerDevTools } from '@bam.tech/react-navigation-visualizer-dev-plugin';
import { useReactNavigationDevTools } from '@dev-plugins/react-navigation';
import { useNavigationContainerRef } from 'expo-router';
import React from 'react';
import { isWeb } from 'smoothie';

import type { ContainerComponent } from '../../common/types/Common';
import SentryFacade from '../../logger/sentry/SentryFacade';

const RegisterRoutingInstrumentation: ContainerComponent = ({ children }) => {
    const navigationRef = useNavigationContainerRef();

    // For development builds, add debugging for Expo Router: https://docs.expo.dev/debugging/devtools-plugins/#react-navigation.
    useReactNavigationDevTools(navigationRef);
    useReactNavigationVisualizerDevTools(navigationRef);

    // Register the navigation ref with instrumentation for Sentry.
    const shouldRegisterRoutingInstrumentation = !isWeb;
    React.useEffect(() => {
        if (shouldRegisterRoutingInstrumentation) {
            SentryFacade.navigationIntegration.registerNavigationContainer(
                navigationRef,
            );
        }
    }, [navigationRef]);

    return <>{children}</>;
};

export default RegisterRoutingInstrumentation;
